module.exports = __webpack_public_path__ + "static/media/job_commercial_type.4bb8c397.svg";